<template>
  <div v-if="sadHomeModal" class="area-sad-home">
    <div>
      <div class="banner-sad">
        <div>
          <span v-if="!timerPause" class="item--close">
            <div class="timer">
              {{ count }}
            </div>
          </span>
          <div class="item--close-i" @click="closesad">
            <div>
              <font-awesome-icon class="item--close-icon" icon="times" />
            </div>
          </div>
          <a :href="link" target="_blank">
            <figure v-if="img" class="img-area">
              <img :src="img" alt="" />
            </figure>
            <!-- <div class="video-area">
              <video :src="img" autoplay></video>
            </div> -->
          </a>
        </div>
      </div>
      <!-- 
          :class="{ timesHiden: !platforms_search.length }" -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HomeBarComponent",
  props: {
    img: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    sadHomeModal: true,
    count: 10,
    timerPause: false,
  }),
  created() {
    this.initCounter();
  },
  computed: mapState(["menuLeftAsside"]),
  methods: {
    closesad() {
      this.sadHomeModal = false;
    },
    timer() {
      if (!this.timerPause) {
        this.count = this.count - 1;
        if (this.count <= 0) {
          this.timerPause = true;
          this.sadHomeModal = false;
        }
      }
    },

    initCounter() {
      setInterval(this.timer, 1000);

      // $(".circle-timer").click(function () {
      //   $(this).toggleClass("paused");
      //   if ($(this).hasClass("paused")) {
      //     timerPause = true;
      //   } else {
      //     timerPause = false;
      //   }
      // });
    },
  },
};
</script>

<style scoped>
.area-sad-home {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0px;
  z-index: 99999;
}
.banner-sad {
  height: 100vh;
  width: 100vw;
  background-color: rgba(44, 56, 72, 0.8);

  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.banner-sad > div {
  position: relative;
  /* height: 90vh;
  width: 90vw; */
  background-color: #2c3848;
}

.banner-sad--close {
  padding: 0px 10px;
  color: white;
  z-index: 99999;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: -12.5px;
  width: 32px;
  height: 32px;
  border: 1px solid #cdcdcd;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  top: -12.5px;
  background: #2c3848;
}
.item--close-i {
  position: absolute;
  right: -12.5px;
  width: 32px;
  height: 32px;
  border: 1px solid #cdcdcd;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  bottom: -12.5px;
  background: #2c3848;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  align-content: center;
}
.item--close-icon {
  font-size: 15px;
  z-index: 1001;
}

.timer {
  width: 32px;
  height: 32px;
  font-size: 15px;
  z-index: 1001;
  padding-top: 5px;
  padding-bottom: 3px;
  border-radius: 50%;
}

.img-area {
  margin: 0px;
  height: 80vh;
  max-width: 80vw;
}
.img-area > img {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.video-area {
  margin: 0px;
  height: 80vh;
}
.video-area > video {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);

  width: 100%;
  height: 100%;
}

@media (max-width: 1000px) {
  .img-area {
    height: 100%;
  }
}
</style>
